import React from 'react';
import { CheckCircle, Lock } from 'lucide-react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { ExtraBonus } from './ExtraBonus';
export function PurchaseSection() {
  const handlePurchase = () => {
    window.location.href = 'https://checkout.ebookpoint.shop/cart/59589844435025:1';
  };
  return <section id="comprar" className="w-full py-10 md:py-14 bg-gradient-to-b from-white to-emerald-50" data-id="element-197">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-199">
          <CountdownTimer data-id="element-200" />

          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-4 border-emerald-200" data-id="element-201">
            <div className="bg-gradient-to-r from-emerald-600 to-emerald-700 text-white text-center py-4 md:py-5" data-id="element-202">
              <h2 className="text-2xl md:text-3xl font-bold mb-1" data-id="element-203">
                Megapack NutriEficiente
              </h2>
              <p className="text-emerald-100 text-sm md:text-base" data-id="element-204">
                Acceso inmediato y completo
              </p>
            </div>

            <div className="p-5 md:p-7" data-id="element-205">
              <ExtraBonus data-id="element-206" />

              <div className="text-center mb-5" data-id="element-207">
                <div className="text-slate-500 text-xl line-through mb-1" data-id="element-208">
                  $59.990
                </div>
                <div className="text-5xl md:text-6xl font-bold text-emerald-600 mb-2" data-id="element-209">
                  $19.990
                </div>
                <div className="text-slate-600 text-sm md:text-base" data-id="element-210">
                  Pago único · Acceso inmediato · Sin suscripciones
                </div>
              </div>

              <div className="space-y-2 mb-6" data-id="element-211">
                <div className="flex items-start gap-2.5" data-id="element-212">
                  <CheckCircle className="w-5 h-5 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-213" />
                  <span className="text-slate-700 text-sm md:text-base" data-id="element-214">
                    5 Tomos completos con 50 capítulos
                  </span>
                </div>
                <div className="flex items-start gap-2.5" data-id="element-215">
                  <CheckCircle className="w-5 h-5 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-216" />
                  <span className="text-slate-700 text-sm md:text-base" data-id="element-217">
                    5 Bonos exclusivos GRATIS (valor $30.000)
                  </span>
                </div>
                <div className="flex items-start gap-2.5" data-id="element-218">
                  <CheckCircle className="w-5 h-5 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-219" />
                  <span className="text-slate-700 text-sm md:text-base" data-id="element-220">
                    BONO EXTRA: Mini Centro de Evaluación
                  </span>
                </div>
                <div className="flex items-start gap-2.5" data-id="element-221">
                  <CheckCircle className="w-5 h-5 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-222" />
                  <span className="text-slate-700 text-sm md:text-base" data-id="element-223">
                    Acceso inmediato y de por vida
                  </span>
                </div>
                <div className="flex items-start gap-2.5" data-id="element-224">
                  <CheckCircle className="w-5 h-5 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-225" />
                  <span className="text-slate-700 text-sm md:text-base" data-id="element-226">
                    Actualizaciones sin costo adicional
                  </span>
                </div>
              </div>

              <button onClick={handlePurchase} className="w-full bg-gradient-to-r from-emerald-600 to-emerald-700 hover:from-emerald-700 hover:to-emerald-800 text-white font-bold text-lg md:text-xl py-4 md:py-5 px-6 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 flex items-center justify-center gap-3 mb-4" data-id="element-227">
                <Lock className="w-5 h-5 md:w-6 md:h-6" data-id="element-228" />
                QUIERO EL MEGAPACK AHORA
              </button>

              <div className="text-center text-xs md:text-sm text-slate-500 flex items-center justify-center gap-2" data-id="element-229">
                <Lock className="w-3.5 h-3.5" data-id="element-230" />
                Compra 100% segura y encriptada
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}